import { Pricing, Product, ProductColumnsIds } from '@setvi/shared/interfaces';
import { Price } from './price';
import { Cost } from './cost';
import { Profit } from './profit';
import { Discount } from './discount';

interface PricingProps {
  product: Product;
  pricing: Pricing;
}

export const getProductDetailsPricing = ({
  pricing,
  product
}: PricingProps) => {
  const content = {
    [ProductColumnsIds.Price]: (
      <Price label={pricing.label} value={product?.price} bold={pricing.bold} />
    ),
    [ProductColumnsIds.Cost]: (
      <Cost label={pricing.label} value={product?.cost} />
    ),
    [ProductColumnsIds.CustomerCost]: (
      <Cost label={pricing.label} value={product?.cost} />
    ),
    [ProductColumnsIds.GP]: (
      <Profit
        label={pricing.label}
        price={product?.price}
        cost={product?.cost}
      />
    ),
    [ProductColumnsIds.Discount]: (
      <Discount
        label={pricing.label}
        price={product?.price}
        cost={product?.cost}
      />
    )
  };

  return content[pricing.id];
};
